import moment from 'moment'
import React from 'react'

//noinspection JSUnresolvedVariable
import {isEqual} from 'lodash'
import colors from "../../modules/theme/colors";
import { dateRanges } from '../../modules/listings/ListingFilterStore';
import { bindShallow } from '../../uiMigration/bindAngularWithMobx';
import SelectedLocationsStore from '../../services/locations/SelectedLocationsStore';
import listingFilterStore from '../../modules/listings/ListingFilterStore';
import * as mobx from 'mobx';

angular.module('clientDashboardApp').controller("LocalSearchAnalyticsCtrl",
  function (
    $scope, $q, $state, $location, $timeout,
    locationService, localSearchAnalyticsService, percentageFilter, numberAbbreviatorFilter, numberFilter, userService, credentialService, reactContainer
  ) {

    const themedColors = colors({nColors: 12});

    // Ensures a color is always returned, even if out of bounds
    const getColor = (i) => {
      let len = themedColors.length-1;
      if(i > len) return getColor(i-len);
      else return themedColors[i];
    }

    const totalActionsColor = getColor(5);

    // Display spinner while api request in progress
    $scope.loadingResults = true;
    $scope.hasData = true;
    $scope.selectedGroupMetric = "actions";

    userService.currentUser()
      .then(userInfo => {
        $scope.userCanManageExternalAccounts = userInfo.permissions.find(x => x === "ManageExternalAccounts") !== undefined
        if ($scope.userCanManageExternalAccounts) {
          credentialService.searchCredentials({})
            .then(credentials => {
              $scope.accountHasCredentials = credentials.find(x => x.credential.provider === "GOOGLEMAP" && x.credential.isValid === true) !== undefined;
            })
        }
      })

    $scope.reportRanges = dateRanges

    $scope.filters = {}

    $scope.$watch('selectedGroupMetric', () => {
      $scope.hasRenderedChart = false;
      updateStats();
    })

    const updateStats = () => {
      if(!$scope.hasRenderedChart){
        if($scope.selectedGroupMetric.contains("searchAppearances")) updateSearchAppearances();
        else if($scope.selectedGroupMetric.contains("searchDetails")) updateSearchDetails();
        else updateActions();

        $scope.hasRenderedChart = true;
      }
    }

    const updateSearchAppearances = () => {
      if(
        $scope.searchAppearancesHistoryPeriods !== undefined && $scope.searchAppearancesHistoryPeriods !== null && $scope.searchAppearancesHistoryPeriods.dates !== undefined
        && $scope.searchAppearanceStats !== undefined && $scope.searchAppearanceStats !== null ) {

        $scope.statsHeader = $scope.searchAppearancesHeader.displayName;
        $scope.statsTooltip = $scope.searchAppearancesHeader.tooltip;
        drawMetricComparisonVisualization("comparisonVisualization", $scope.searchAppearanceStats)
        drawMetricHistoryVisualization("historyVisualization", $scope.searchAppearancesHistoryPeriods)
        drawMetricsColumnVisualization("visualization", $scope.searchAppearanceStats)
      }
    }

    const updateSearchDetails = () => {
      if(
        $scope.searchDetailsHistoryPeriods !== undefined && $scope.searchDetailsHistoryPeriods !== null && $scope.searchDetailsHistoryPeriods.dates !== undefined
        && $scope.searchDetailsStats !== undefined && $scope.searchDetailsStats !== null  ) {

        $scope.statsHeader = $scope.searchDetailsHeader.displayName;
        $scope.statsTooltip = $scope.searchDetailsHeader.tooltip;
        drawMetricComparisonVisualization("comparisonVisualization", $scope.searchDetailsStats)
        drawMetricHistoryVisualization("historyVisualization", $scope.searchDetailsHistoryPeriods)
        drawMetricsColumnVisualization("visualization", $scope.searchDetailsStats)
      }
    }

    const updateActions = () => {
      if(
        $scope.actionsHistoryPeriods !== undefined && $scope.actionsHistoryPeriods !== null && $scope.actionsHistoryPeriods.dates !== undefined
        && $scope.actionsStats !== undefined && $scope.actionsStats !== null ) {

        $scope.statsHeader = $scope.actionsHeader.displayName;
        $scope.statsTooltip = $scope.actionsHeader.tooltip;
        drawMetricComparisonVisualization("comparisonVisualization", $scope.actionsStats)
        drawMetricHistoryVisualization("historyVisualization", $scope.actionsHistoryPeriods)
        drawMetricsColumnVisualization("visualization", $scope.actionsStats)
      }
    }

    const getProvider = () => {
      let rtn;
      const providers = $scope.validProviders;

      if (
        providers !== undefined
        && Array.isArray(providers)
        && providers.length > 0
        && providers[0] !== undefined
      ) {

        if(
          $state.params.provider !== undefined
          && !Array.isArray($state.params.provider)
          && providers.find(x => x.toUpperCase() === $state.params.provider.toUpperCase()) !== undefined
        ) {

          rtn = $state.params.provider;
        } else if (
          Array.isArray($state.params.provider)
          && $state.params.provider[0] !== undefined
          && providers.find(x => x.toUpperCase() === $state.params.provider[0].toUpperCase()) !== undefined
        ) {

          rtn = $state.params.provider[0];
        } else {

          $state.params.provider = providers[0];
          rtn = providers[0];
        }

      }
      return rtn;
    }

    $scope.searchConfig = {};
    bindShallow($scope, $scope.searchConfig, listingFilterStore.state, {
      initializeFromMobx: true,
      mobxToAngular: ({ groupId, ...rest }) => rest,
    });
    $scope.$on(
      "$destroy",
      mobx.reaction(
        () => SelectedLocationsStore.legacyGroupIdOrAll,
        (groupId) => ($scope.searchConfig.groupId = groupId),
        {
          fireImmediately: true,
        }
      )
    );

    $scope.getProviderImageUrl = () => {
      if($scope.searchConfig.localSearchAnalyticsProvider) {
        return `${assetUrl}/images/providers/${$scope.searchConfig.localSearchAnalyticsProvider.toLowerCase()}.svg`
      }
    }

    $scope.$watch("searchConfig", function (newConfig, oldConfig) {

      if (!$scope.searchConfig) {
        return
      }

      $scope.showGroups = $scope.searchConfig.showGroups;
      // Nullify generated report when search config changes
      $scope.generatingReport = false
      $scope.reportLink = null
      $scope.generatingStoreComparisonReport = false
      $scope.storeComparisonReportLink = null

      // Get difference between start date and end date
      // Report runs too slowly w/ large number of locations and large date range
      const endDate = $scope.searchConfig.endDate !== undefined ? moment($scope.searchConfig.endDate) : moment()
      $scope.daysInDateRange = endDate.diff(moment($scope.searchConfig.startDate), "days")

      if (isEqual(newConfig, oldConfig)) {
        return;
      }

      const convertedConfig = {...$scope.searchConfig, reportType: $scope.searchConfig.reportType}
      delete convertedConfig.reportType;

      $location.search(Object.assign({}, convertedConfig, {})) // Update url
      if (wereOnlyGroupConfigsChanged(oldConfig, newConfig)) {
          reloadResultsTable()
      } else {
          reloadEverything()
      }
    }, true)


    $scope.comparePreviousPeriod = true;

    $scope.searchDetailsStats = {};
    $scope.searchAppearanceStats = {};
    $scope.actionsStats = {};

    $scope.searchDetailsHistoryPeriods = {};
    $scope.searchAppearancesHistoryPeriods = {};
    $scope.actionsHistoryPeriods = {};

    $scope.combinedSearchAppearancesStats = {};
    $scope.combinedActionsStats = {};
    $scope.combinedSearchStats = {};


    $scope.locations = [];
    $scope.groups = [];
    $scope.all = [];

    $scope.filters.comparePreviousPeriod = false;

    const setTotals = (left, middle, right) => {
      $scope.leftTotalsDelta = left.delta;
      $scope.leftTotals = left.total;
      $scope.leftTotalsTooltip = left.tooltip;
      $scope.leftTotalsTitle = left.displayName;


      $scope.middleTotalsDelta = right.delta;
      $scope.middleTotals = right.total;
      $scope.middleTotalsTooltip = right.tooltip;
      $scope.middleTotalsTitle = right.displayName;


      $scope.rightTotalsDelta = middle.delta;
      $scope.rightTotals = middle.total;
      $scope.rightTotalsTooltip = middle.tooltip;
      $scope.rightTotalsTitle = middle.displayName;
    }

    /*
     * Metric Comparison with Pie Chart
     */
    const drawMetricComparisonVisualization = (id, stats) => {
      Highcharts.chart(id, {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false
        },
        title: {
          text: '',
        },
        tooltip: {
          formatter: function () {
            return '<b>' +this.key + ':</b> ' + numberFilter(this.y, 0) + ' (' + this.percentage.toFixed(1) + '%)'
          },
          useHTML: true
        },
        legend: {
          itemWidth: 180 // To Ensure the spacing of items looks uniform.
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false
            },
            showInLegend: true,
            borderWidth: 0,
          }
        },
        credits: {
          enabled: false
        },
        series: [{
          type: 'pie',
          name: 'Search Comparison',
          innerSize: '55%',
          data: getVisualizationDataSeriesTotal(stats)
        }],
        exporting: { enabled: false }
      })
    }

    const getVisualizationDataSeriesTotal = (data) => {
      let series = [];
      for (let i = 0; i < data.length; i++){
        let metric = data[i];
        series.push({name: metric.displayName, y: metric.total, color: getColor(i)});
      }
      return series;
    }

    /*
     * By Time Visualization
     */
    const drawMetricHistoryVisualization = (id, metricHistory) => {
      Highcharts.chart(id, {
        chart: {
          marginRight: 30
        },
        title: {
          text: '',
        },
        legend: {
          symbolHeight: 12,
          symbolWidth: 12,
          symbolRadius: 6,
          margin: 30,
          itemWidth: 180 // To Ensure the spacing of items looks uniform.
        },
        tooltip: {
          formatter: (function (historyStats) {
            return function () {
              let rtn = "<div class='sentiment-chart-tooltip'><div><label>Period:</label><span>" + historyStats.dates[this.x] + "</span></div>";
              for (let i = 0; i < historyStats.metrics.length; i++){
                let metric = historyStats.metrics[i];
                let value = metric.values[this.x];
                rtn += "<div><label>" + metric.displayName + ":</label><span>" +  numberFilter(value, 0) + "</span></div>"
              }
              rtn += "</div>";
              return rtn;
            }
          })(metricHistory),
          useHTML: true
        },
        xAxis: {
          type: 'datetime',
          labels: {
            y: 20,
            enabled: true,
            formatter: function () {
              return `<span>${metricHistory.dates[this.value] || ''}</span>`
            },
            useHTML:true,
            rotation: 0,
            staggerLines: 1
          },
          minorTickLength: 0,
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: null,
          },
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          series: {
            connectNulls: true,
            marker: {
              enabled: false,
            },
          },
        },
        series: getHistoryStatsDataSeries(metricHistory),
        exporting: { enabled: false }
      })
    }

    /*
     * Metric Comparison with Bar Charts
     */
    const drawMetricsColumnVisualization = (id, stats) => {
      Highcharts.chart(id, {
        title: {
          text: '',
        },
        chart: {
          type: 'column',
          marginTop: 50
        },
        xAxis: {
          minorTickLength: 0,
          gridLineWidth: 0,
          tickLength: 0,
          tickWidth: 0,
          tickPosition: 'outside',
          lineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: 'transparent',
          title: {
            text: null,
          },
          labels: {
            formatter: function () {
              if(this !== undefined) return stats[this.value].displayName
            },
            useHTML: true
          }
        },
        tooltip: {
          enabled: false
        },
        yAxis: {
          categories: ['A', 'B', 'C'],
          gridLineWidth: 0,
          minorTickLength: 0,
          tickLength: 0,
          tickWidth: 0,
          tickPosition: 'outside',
          labels: {
            enabled: false,
            align: 'right',
            x:-10,
            y:5
          },
          lineWidth:0,
          title: {
            text: null,
          },
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          column: {
            dataLabels: {
              formatter: (function (stats) {
                return function() {
                  const delta = stats[this.x].delta;
                  const deltaClass = delta === 0 ? '' : (delta > 0 ? 'text-success' : 'text-danger')

                  return '<div class="d-flex flex-column align-items-center justify-content-center">' +
                      '<div class="d-flex justify-content-center align-items-center">' +
                        (delta !== 0 && $scope.enoughDataForPercentages ? '<span class="' + deltaClass + ' font-weight-normal" uib-tooltip="The percent change between the selected date range, and the previous date range of equal size.">' + percentageFilter(delta, 0, false) + '</span>' : '') +
                      '</div>' +
                      '<div class="d-flex justify-content-center metric-value text-body font-weight-normal">' +
                        numberAbbreviatorFilter(this.y) +
                      '</div>' +
                    '</div>'
                }
              }(stats)),
              useHTML: true,
              enabled: true,
              crop: false,
              overflow: 'none',
              allowOverlap: true // Set to true if labels need to appear.
            }
          },
          series: {
            pointWidth: 65,
            allowPointSelect: false
          }
        },
        series: [
          {
            color: totalActionsColor,
            showInLegend:false,
            data: getVisualizationDataSeriesTotal(stats)
          },
        ],
        exporting: { enabled: false }
      })
    }

    const getHistoryStatsDataSeries = (data) => {
      // Display a marker if there is only one data point (no line can be made from a single point)
      let markerEnabled = data.dates.length < 2
      const marker = {
        enabled: markerEnabled,
        radius: 5,
        symbol: "circle",
      }

      let series = [];
      for (let i = 0; i < data.metrics.length; i++){
        let metric = data.metrics[i];
        series.push({name: metric.displayName, data: metric.values, marker, color: getColor(i)});
      }
      return series;
    }

    const fetchInsights = () => {
      $scope.searchAppearancesEmpty = true;
      $scope.actionsEmpty = true;
      $scope.searchDetailsEmpty = true;

      return localSearchAnalyticsService
        .getInsights($scope.searchConfig.localSearchAnalyticsProvider, $scope.searchConfig.groupId, $scope.searchConfig.startDate, $scope.searchConfig.endDate)
        .then((resp) => {

          $scope.searchDetailsStats = resp.data.searchDetailsStats;
          $scope.searchAppearanceStats = resp.data.searchAppearanceStats;
          $scope.actionsStats = resp.data.actionsStats;

          $scope.searchDetailsHistoryPeriods = resp.data.searchDetailsHistoryPeriods;
          $scope.searchAppearancesHistoryPeriods = resp.data.searchAppearancesHistoryPeriods;
          $scope.actionsHistoryPeriods = resp.data.actionsHistoryPeriods;

          $scope.combinedSearchAppearancesStats = resp.data.combinedSearchAppearancesStats;
          $scope.combinedActionsStats = resp.data.combinedActionsStats;
          $scope.combinedSearchDetailsStats = resp.data.combinedSearchDetailsStats;

          $scope.searchAppearancesHeader = resp.data.searchAppearancesHeader;
          $scope.searchDetailsHeader = resp.data.searchDetailsHeader;
          $scope.actionsHeader = resp.data.actionsHeader;

          $scope.enoughDataForPercentages = resp.data.enoughDataForPercentages;

          if($scope.searchDetailsHistoryPeriods.dates.length > 0) $scope.searchDetailsEmpty = false;
          if($scope.searchAppearancesHistoryPeriods.dates.length > 0) $scope.searchAppearancesEmpty = false;
          if($scope.actionsHistoryPeriods.dates.length > 0) $scope.actionsEmpty = false;

          if($scope.combinedSearchAppearancesStats !== undefined && $scope.combinedSearchAppearancesStats !== null
            && $scope.combinedActionsStats !== undefined && $scope.combinedActionsStats !== null
            && $scope.combinedSearchDetailsStats !== undefined && $scope.combinedSearchDetailsStats !== null ) {

            setTotals($scope.combinedSearchAppearancesStats,$scope.combinedActionsStats,$scope.combinedSearchDetailsStats);
          }
          if($scope.searchAppearancesEmpty && $scope.actionsEmpty && $scope.searchDetailsEmpty) $scope.hasData = false;

        })
    }


    $scope.pagedLocations = [];
    const locationsPerPage = 10

    $scope.sortDirection = 1
    $scope.pageNumber = 0 // zero-indexed pages
    $scope.pages = []
    let totalPages = 0

    const updatePagedLocations = () => {
      $scope.pagedLocations = $scope.storedComparisonRows.slice($scope.pageNumber * locationsPerPage, ($scope.pageNumber + 1) * locationsPerPage);

      totalPages = $scope.storedComparisonRows.length / locationsPerPage
      $scope.pages = []
      for (let i = 0; i < totalPages; i++) { $scope.pages.push(i) }
    }

    $scope.goToPage = (newPageNumber) => {
      const zeroIndexedPageNumber = newPageNumber - 1
      if (zeroIndexedPageNumber >= 0 && zeroIndexedPageNumber <= totalPages) {
        $scope.pageNumber = zeroIndexedPageNumber
      }

      updatePagedLocations()
    }


    $scope.sortField = "locationAddress"
    $scope.sortBy = (column) => {
      if ($scope.sortField === column) {
        // If we are already sorting by this field, flip direction
        $scope.sortDirection = $scope.sortDirection * -1
      } else {
        $scope.sortDirection = -1
      }
      if(column !== undefined) $scope.sortField = column;

      if($scope.sortField.contains("_")) {
        let columnID = $scope.sortField.split("_")[1];
        if ($scope.sortField.contains("location_")) {
          !!$scope.storedComparisonRows && $scope.storedComparisonRows.sort( (a, b) => {
            return sorter(a.locationName, b.locationName);
          });
          !!$scope.groupsStoredComparisonRows && $scope.groupsStoredComparisonRows.sort( (a, b) => {
            return sorter(a.locationName, b.locationName);
          });
        } else if ($scope.sortField.contains("searchDetails_")) {
          !!$scope.storedComparisonRows && $scope.storedComparisonRows.sort( (a, b) => {
            return sorter(a.searchDetails[columnID].current, b.searchDetails[columnID].current);
          });
          !!$scope.groupsStoredComparisonRows && $scope.groupsStoredComparisonRows.sort( (a, b) => {
            return sorter(a.searchDetails[columnID].current, b.searchDetails[columnID].current);
          });
        } else if ($scope.sortField.contains("actions_")) {
          !!$scope.storedComparisonRows && $scope.storedComparisonRows.sort( (a, b) => {
            return sorter(a.actions[columnID].current, b.actions[columnID].current);
          });
          !!$scope.groupsStoredComparisonRows && $scope.groupsStoredComparisonRows.sort( (a, b) => {
            return sorter(a.actions[columnID].current, b.actions[columnID].current);
          });
        } else if ($scope.sortField.contains("searchAppearances_")) {
          !!$scope.storedComparisonRows && $scope.storedComparisonRows.sort( (a, b) => {
            return sorter(a.searchAppearances[columnID].current, b.searchAppearances[columnID].current);
          });
          !!$scope.groupsStoredComparisonRows && $scope.groupsStoredComparisonRows.sort( (a, b) => {
            return sorter(a.searchAppearances[columnID].current, b.searchAppearances[columnID].current);
          });
        }
      } else {
        $scope.storedComparisonRows.sort( (a, b) => {
          return sorter(a.locationAddress, b.locationAddress);
        });
        $scope.groupsStoredComparisonRows.sort( (a, b) => {
          return sorter(a.locationAddress, b.locationAddress);
        });
      }

      if($scope.sortDirection === -1){
        !!$scope.storedComparisonRows && $scope.storedComparisonRows.reverse()
        !!$scope.groupsStoredComparisonRows && $scope.groupsStoredComparisonRows.reverse()
      }

      $scope.goToPage(1)
      updatePagedLocations()
    }

    const sorter = (valueA, valueB) => {
      if (!valueA && !valueB) return 0
      if (valueA < valueB) {
        return -1;
      }
      else if (valueA > valueB) {
        return 1;
      }
      return 0;
    }

    $scope.exportLocations = () => {
      localSearchAnalyticsService.exportLocations($scope.searchConfig.localSearchAnalyticsProvider, $scope.searchConfig.groupId, $scope.searchConfig.startDate, $scope.searchConfig.endDate)
    }
    $scope.exportStoredComparision = (byGroups) => {
      localSearchAnalyticsService.exportStoreComparison($scope.searchConfig.localSearchAnalyticsProvider, $scope.searchConfig.groupId, $scope.searchConfig.startDate, $scope.searchConfig.endDate, byGroups)
    }

    const reloadEverything = _.debounce(() => {
      $scope.loadingResults = true;
      $scope.hasData = true;
      $scope.hasRenderedChart = false;
       !!$scope.loadingResults && fetchInsights()
        .then(() => {
          if($scope.searchDetailsHistoryPeriods.dates.length > 0) $scope.searchDetailsEmpty = false;
          if($scope.searchAppearancesHistoryPeriods.dates.length > 0) $scope.searchAppearancesEmpty = false;
          if($scope.actionsHistoryPeriods.dates.length > 0) $scope.actionsEmpty = false;
          if($scope.loadingResults && !$scope.hasRenderedChart){
            updateStats();
          }
          $scope.loadingResults = false;
        }, (reason) => {
          $scope.loadingResults = false;
          $scope.hasData = false;
        })
        reloadResultsTable();
    }, 200)

    const reloadResultsTable = _.debounce(() => {
      if ($scope.showGroups) {
        getDetailedGroupsInsights();
      }
      //getDetailedLocationsInsights();
    }, 200)


    const getDetailedGroupsInsights = () => {
      if (!$scope.groupsLoading) {
        $scope.groupsEmpty = true;
        $scope.groupsLoading = true;
        return localSearchAnalyticsService
          .getDetailedGroupInsights($scope.searchConfig.localSearchAnalyticsProvider, $scope.searchConfig.groupId, $scope.searchConfig.startDate, $scope.searchConfig.endDate)
          .then(resp => {
            $scope.groupsStoredComparisonRows = resp.data.groupsStoredComparisonRows;
            if ($scope.groupsStoredComparisonRows.length > 0) $scope.groupsEmpty = false;
            $scope.groupsLoading = false;
          })
      }
    }


    localSearchAnalyticsService.getProviders()
      .then(resp => {
        $scope.validProviders = resp.data.providers;
        reactContainer.getContainer().setLocalSearchAnalyticsProviderOptions(resp.data.providers);
        if ($scope.searchConfig.localSearchAnalyticsProvider === undefined) {
          const singleProvider = getProvider();
          reactContainer.getContainer().setLocalSearchAnalyticsProvider(singleProvider);
          $scope.searchConfig.localSearchAnalyticsProvider = singleProvider;
        }
        else {
          reloadEverything()
        }
      })


  $scope.tooltip = (metric) => {
    switch(metric) {
      case "SEARCHDETAILS": return "The number of times a listing detail was viewed."
      case "SEARCHAPPEARANCES": return "The number of times a listing appeared in search results."
      case "ACTIONS": return "The sum of all user actions on a listing."

      /*
       * Search Appearance Metrics
       */
      case "MAPSEARCH": return "The number of times a listing appeared in search results on Google Maps."
      case "SEARCH": return "The number of times a listing appeared in a Google search."
      case "MOBILETRAFFIC": return "The number of times a listing appeared in searches on mobile devices."
      case "DESKTOPTRAFFIC": return "The number of times a listing appeared in searches on desktop devices."


      /*
       * Action metrics
       */
      case "WEBSITE": return "The number of clicks to the business website URL from a listing."
      case "DRIVINGDIRECTIONS": return "The number of driving direction and map views from a listing."
      case "MOBILECHECKINS": return "The number of mobile check-ins from a listing."
      case "CALLS": return "The number of phone calls initiated from a listing."
      case "MESSAGES": return "The number of messages initiated from a listing."
      case "BOOKMARKS": return "The number of times a listing has been bookmarked by users."
      case "DESKTOPACTIONS": return "The number of Call-to-Action clicks on desktop devices."
      case "MOBILEACTIONS": return "The number of Call-to-Action clicks on mobile devices."
      case "BUSINESSPHOTOVIEWS": return "The number of views on media items uploaded by the business."
      case "USERPHOTOVIEWS": return "The number of views on media items uploaded by customers."
      case "BUSINESSPHOTOCOUNT": return "The total number of media items that are currently live that have been uploaded by the business."
      case "USERPHOTOCOUNT": return "The number of user generated photos associated to the listing."
      case "BUSINESSPHOTOSADDED": return "The number of photos added to the business profile by the business."
      case "USERPHOTOSADDED": return "The number of photos added to the business profile by users."
      case "POSTACTIONS": return "The number of times the call to action button was clicked on a Google Post."
      case "POSTVIEWSLOCAL": return "The number of times a Google Post was viewed in local searches."
      case "POSTVIEWSSEARCH": return "The number of times a Google Post was viewed in Google searches."

      /*
       * Searches metrics
       */
      case "DIRECT": return "The number of times a user searched for a listing using keywords or branding that are associated with listings' chain."
      case "INDIRECT": return "The number of times a customer searched for a category, product, or service that you offer, and your listing appeared."
      case "CHAIN": return "The number of times a user searched for a listing using keywords or branding that are associated with listings' chain."
      case "DESKTOP": return "The number of times a listing has been viewed on a desktop."
      case "MOBILE": return "The number of times a listing has been viewed on a mobile device."


      /*
       * Aggregate metrics
       */
      case "PHOTOVIEWS": return "The number of views on media items uploaded by the listing owner and customer."
      case "PHOTOCOUNT": return "The number of photos added to the business profile (User or otherwise)"
      case "PHOTOTOTAL": return "The number of photos associated to a listing (User or otherwise)"
      case "POSTVIEWSTOTAL": return "The number of times the local post was viewed on Google Search."

      default: return "To view more, please download the data."
    }
  }

})

function wereOnlyGroupConfigsChanged(oldConfig, newConfig) {
    const {showGroups: showGroupsOld, ...othersOld} = oldConfig
    const {showGroups: showGroupsNew, ...othersNew} = newConfig

    return showGroupsNew !== showGroupsOld && isEqual(othersOld, othersNew)
}
